import { useCallback, useRef, useState } from 'react';

export function useDirtyFormGuard(initialDirty = false) {
  const [isDirty, setIsDirty] = useState(initialDirty);
  const dirtyRef = useRef(initialDirty);

  const markDirty = useCallback(() => {
    if (dirtyRef.current) return;
    dirtyRef.current = true;
    setIsDirty(true);
  }, []);

  const setDirty = useCallback((nextValue: boolean) => {
    dirtyRef.current = nextValue;
    setIsDirty(nextValue);
  }, []);

  const resetDirty = useCallback(() => {
    dirtyRef.current = false;
    setIsDirty(false);
  }, []);

  const canApplyRemoteUpdate = useCallback((isEditing: boolean) => !isEditing && !dirtyRef.current, []);

  return { isDirty, dirtyRef, markDirty, setDirty, resetDirty, canApplyRemoteUpdate };
}
